import { IWorkOrder } from 'platforms/store/interfaces';
import * as React from 'react';

import { saveReport } from './ReportItem';

class ReportDownloadAction extends React.Component<Partial<IWorkOrder>> {
  handleDownload = event => {
    const { file, title } = this.props;

    saveReport(event, file, title);
  };
  render() {
    return (
      <span
        onClick={this.handleDownload}
        style={{
          cursor: 'pointer',
          textDecoration: 'underline',
          fontWeight: 'bold',
          color: 'white'
        }}
      >
        DOWNLOAD
      </span>
    );
  }
}

export default ReportDownloadAction;
